import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from './core/services';
import { CONFIG } from './config';

@Component({
    selector: 'rms-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements OnInit {

  public translations: any;

  constructor(
    private translate: TranslateService,
    private authenticationService: AuthenticationService
  ) {
    this.translate.setDefaultLang(CONFIG.defaultLang);
    this.translate.use(this.authenticationService.getLang());
  }

  ngOnInit() {
  }

}
